/* tslint:disable */
/* eslint-disable */
/**
 * ClimatePartner API Order Service
 * A Unified API for all ClimatePartner products
 *
 * The version of the OpenAPI document: 1.3.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CommonErrorBadGateway } from '../models';
// @ts-ignore
import type { CommonErrorBadRequest } from '../models';
// @ts-ignore
import type { CommonErrorGatewayTimeout } from '../models';
// @ts-ignore
import type { CommonErrorInternalServerError } from '../models';
// @ts-ignore
import type { CommonErrorPayloadTooLarge } from '../models';
// @ts-ignore
import type { CommonErrorUnauthorized } from '../models';
// @ts-ignore
import type { CommonErrorUnsupportedMediaType } from '../models';
// @ts-ignore
import type { OrderCheckOrderErrorProjectNotFound } from '../models';
// @ts-ignore
import type { OrderCheckOrderRequest } from '../models';
// @ts-ignore
import type { OrderCheckOrderResponse } from '../models';
// @ts-ignore
import type { OrderErrorNotFound } from '../models';
// @ts-ignore
import type { OrderGetAllInfoResponse } from '../models';
/**
 * OrderServiceApi - axios parameter creator
 */
export const OrderServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns  price and availability of an order for a given amount and project
         * @param {OrderCheckOrderRequest} orderCheckOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkOrder: async (orderCheckOrderRequest: OrderCheckOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderCheckOrderRequest' is not null or undefined
            assertParamExists('checkOrder', 'orderCheckOrderRequest', orderCheckOrderRequest)
            const localVarPath = `/order/v1/checkOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderCheckOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all existing orders that belong to an organisation
         * @param {string} [cursor] Marks the last item return in the previous page. Use this to walk through paginated orders
         * @param {string} [limit] Determines number of orders to return per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOrders: async (cursor?: string, limit?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/order/v1/allOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderServiceApi - functional programming interface
 */
export const OrderServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns  price and availability of an order for a given amount and project
         * @param {OrderCheckOrderRequest} orderCheckOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkOrder(orderCheckOrderRequest: OrderCheckOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderCheckOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkOrder(orderCheckOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderServiceApi.checkOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns all existing orders that belong to an organisation
         * @param {string} [cursor] Marks the last item return in the previous page. Use this to walk through paginated orders
         * @param {string} [limit] Determines number of orders to return per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllOrders(cursor?: string, limit?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderGetAllInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllOrders(cursor, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderServiceApi.getAllOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrderServiceApi - factory interface
 */
export const OrderServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns  price and availability of an order for a given amount and project
         * @param {OrderServiceApiCheckOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkOrder(requestParameters: OrderServiceApiCheckOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderCheckOrderResponse> {
            return localVarFp.checkOrder(requestParameters.orderCheckOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all existing orders that belong to an organisation
         * @param {OrderServiceApiGetAllOrdersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOrders(requestParameters: OrderServiceApiGetAllOrdersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OrderGetAllInfoResponse> {
            return localVarFp.getAllOrders(requestParameters.cursor, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for checkOrder operation in OrderServiceApi.
 */
export interface OrderServiceApiCheckOrderRequest {
    readonly orderCheckOrderRequest: OrderCheckOrderRequest
}

/**
 * Request parameters for getAllOrders operation in OrderServiceApi.
 */
export interface OrderServiceApiGetAllOrdersRequest {
    /**
     * Marks the last item return in the previous page. Use this to walk through paginated orders
     */
    readonly cursor?: string

    /**
     * Determines number of orders to return per page
     */
    readonly limit?: string
}

/**
 * OrderServiceApi - object-oriented interface
 */
export class OrderServiceApi extends BaseAPI {
    /**
     * 
     * @summary Returns  price and availability of an order for a given amount and project
     * @param {OrderServiceApiCheckOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checkOrder(requestParameters: OrderServiceApiCheckOrderRequest, options?: RawAxiosRequestConfig) {
        return OrderServiceApiFp(this.configuration).checkOrder(requestParameters.orderCheckOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all existing orders that belong to an organisation
     * @param {OrderServiceApiGetAllOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllOrders(requestParameters: OrderServiceApiGetAllOrdersRequest = {}, options?: RawAxiosRequestConfig) {
        return OrderServiceApiFp(this.configuration).getAllOrders(requestParameters.cursor, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
}

